import { MapPin, Clock, Navigation } from "lucide-react";
import { BIZ, MAP_EMBED, MAP_LINK } from "../data";
import Reveal from "../components/Reveal";

export default function Location() {
  return (
    <section id="localizacao" className="relative bg-black py-24 sm:py-32" data-testid="location-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-12 max-w-2xl">
          <Reveal>
            <span className="font-display text-sm font-semibold uppercase tracking-[0.35em] text-[--gold]">
              Localização
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-6xl">
              Venha nos <span className="text-[--gold]">conhecer</span>
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1.4fr_1fr]">
          {/* Map */}
          <Reveal>
            <div className="relative h-[340px] overflow-hidden border border-[--gold]/20 sm:h-[440px]">
              <iframe
                title="Mapa +5 Studio Training"
                src={MAP_EMBED}
                className="h-full w-full grayscale-[40%] contrast-125"
                style={{ border: 0, filter: "invert(90%) hue-rotate(180deg)" }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="map-embed"
              />
            </div>
          </Reveal>

          {/* Info */}
          <div className="flex flex-col gap-4">
            <Reveal>
              <div className="border border-[--gold]/15 bg-[--surface] p-7">
                <div className="mb-4 flex items-center gap-3">
                  <MapPin className="h-6 w-6 text-[--gold]" />
                  <h3 className="font-display text-xl font-bold uppercase tracking-tight text-white">
                    Endereço
                  </h3>
                </div>
                <p className="text-base leading-relaxed text-neutral-300">
                  {BIZ.address.line1}
                  <br />
                  {BIZ.address.line2}
                  <br />
                  {BIZ.address.city} · {BIZ.address.cep}
                </p>
                <a
                  href={MAP_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="directions-btn"
                  className="mt-5 inline-flex items-center gap-2 font-display text-sm font-bold uppercase tracking-widest text-[--gold] transition-colors duration-300 hover:text-[--gold-soft]"
                >
                  <Navigation className="h-4 w-4" />
                  Ver rota no mapa
                </a>
              </div>
            </Reveal>

            <Reveal delay={0.08}>
              <div className="border border-[--gold]/15 bg-[--surface] p-7">
                <div className="mb-4 flex items-center gap-3">
                  <Clock className="h-6 w-6 text-[--gold]" />
                  <h3 className="font-display text-xl font-bold uppercase tracking-tight text-white">
                    Horário
                  </h3>
                </div>
                <ul className="divide-y divide-white/5">
                  {BIZ.hours.map((h) => (
                    <li key={h.day} className="flex items-center justify-between py-3">
                      <span className="text-sm text-neutral-300">{h.day}</span>
                      <span
                        className={`font-display text-sm font-bold uppercase tracking-wide ${
                          h.closed ? "text-neutral-500" : "text-white"
                        }`}
                      >
                        {h.time}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
